import { ReactComponent as DeleteIcon } from '@/assets/trash_bin.svg'
import PermissionsController from '@/components/PermissionsController'
import { DATE_TIME_FORMAT } from '@/libs/core/constants'
import Spinner from '@/shared/Spinner'
import AddIcon from '@mui/icons-material/Add'
import Edit from '@mui/icons-material/Edit'
import ArrowDropDown from '@mui/icons-material/KeyboardArrowDown'
import ArrowDropUp from '@mui/icons-material/KeyboardArrowUp'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import moment from 'moment'
import { useState } from 'react'
import { DragDropContext, Draggable } from 'react-beautiful-dnd'
import { useTranslation } from 'react-i18next'
import StrictModeDroppable from './StrictModeDroppable'
import VideoItem from './VideoItem'
import durationToStr from '@/libs/utils/durationToStr'

const ProgramItem = ({
  open,
  loading,
  selectedDetails,
  lastModifiedTime,
  numberofcourseTemp,
  programId,
  name,
  totalVideosTime,
  getDetails,
  onEditCourse,
  onDelete,
  onDeleteCourse,
  onEdit,
  onEditCoursePrograms,
  onCoursePreview,
  onVideoPreview,
  onReorder,
}) => {
  const { t } = useTranslation()
  const { courseTempList = [] } = selectedDetails || {}
  const [dragDisabled, setDragDisabled] = useState(true)

  const renderCourseList = () =>
    courseTempList !== null && courseTempList.length > 0 ? (
      <DragDropContext
        onDragEnd={result => {
          if (!result.destination) return
          const from = result.source.index
          const to = result.destination.index
          onReorder?.({ programId, courseTempId: courseTempList[from].templateId, from, to })
        }}
      >
        <StrictModeDroppable droppableId={programId.toString()}>
          {dropProvided => (
            <div {...dropProvided.droppableProps} ref={dropProvided.innerRef}>
              {courseTempList.map((course, index) => (
                <Draggable
                  key={course.templateId.toString()}
                  draggableId={course.templateId.toString()}
                  index={index}
                  isDragDisabled={dragDisabled}
                >
                  {dragProvided => (
                    <div
                      ref={dragProvided.innerRef}
                      {...dragProvided.draggableProps}
                      {...dragProvided.dragHandleProps}
                      style={dragProvided.draggableProps.style}
                    >
                      <VideoItem
                        {...course}
                        onReorderHover={() => setDragDisabled(false)}
                        onReorderHoverExit={() => setDragDisabled(true)}
                        onPreviewClick={() => {
                          onCoursePreview(course)
                        }}
                        onVideoPreviewClick={() => {
                          onVideoPreview(course)
                        }}
                        onEditCoursePrograms={() => {
                          onEditCoursePrograms(course)
                        }}
                        onDelete={() => {
                          onDeleteCourse({ program: { programId, name }, course })
                        }}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {dropProvided.placeholder}
            </div>
          )}
        </StrictModeDroppable>
      </DragDropContext>
    ) : (
      <Box
        sx={{
          display: 'flex',
          height: 100,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="h6">{t('errors.no_course')}</Typography>
      </Box>
    )

  return (
    <Stack sx={{ my: 1 }}>
      <Card sx={{ borderRadius: 0 }}>
        <CardContent>
          <Stack flexDirection={'row'} alignItems={'center'}>
            <Stack flex={1} gap={1}>
              <Stack flexDirection={'row'} gap={1}>
                <Typography
                  width={300}
                  fontWeight={'bold'}
                  color={theme => theme.palette.secondary_80.main}
                >{`${name} (${numberofcourseTemp}) ${t('general.total_time')}: ${durationToStr(
                  totalVideosTime,
                )}`}</Typography>

                <PermissionsController permission="courseVideosList_modify">
                  <IconButton size="small" sx={{ padding: 0, color: '#2D2D6C' }} onClick={onEdit}>
                    <Edit />
                  </IconButton>
                </PermissionsController>

                <PermissionsController permission="courseVideosList_create">
                  <IconButton
                    size="small"
                    sx={{ padding: 0, color: '#2D2D6C' }}
                    onClick={onEditCourse}
                  >
                    <AddIcon />
                  </IconButton>
                </PermissionsController>

                <PermissionsController permission="courseVideosList_delete">
                  <IconButton size="small" sx={{ padding: 0, color: '#2D2D6C' }} onClick={onDelete}>
                    <DeleteIcon />
                  </IconButton>
                </PermissionsController>
              </Stack>
              <Typography variant="caption" color={theme => theme.palette.grey_60.main}>{`${t(
                'general.last_modified_time',
              )}: ${moment(lastModifiedTime).format(DATE_TIME_FORMAT)}`}</Typography>
            </Stack>
            <IconButton onClick={getDetails}>
              {open ? <ArrowDropUp /> : <ArrowDropDown />}
            </IconButton>
          </Stack>
        </CardContent>
      </Card>
      {open &&
        (loading ? (
          <Box
            sx={{
              display: 'flex',
              height: 100,
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Spinner />
          </Box>
        ) : (
          renderCourseList()
        ))}
    </Stack>
  )
}

export default ProgramItem
